import { render, staticRenderFns } from "./editArt.vue?vue&type=template&id=1d8ac0b6&"
import script from "./editArt.vue?vue&type=script&lang=js&"
export * from "./editArt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports